
export default {
  props: {
    officialList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isShow: false
    }
  },
  computed: {
  },
  mounted() {
  },
  methods: {
  },
}
